import styled from "styled-components";

import { colorsPalettes, setElevation } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

export const DunningsLinkText = styled(Text)`
    color: ${colorsPalettes.carbon[400]};
    text-decoration: underline;
`;

export const DunningsSectionWrapper = styled(Flex)`
    justify-content: space-between;
    align-items: flex-start;
    min-width: 900px;
    max-width: 980px;
    gap: 24px;
    padding: 24px;
    margin: 28px 40px;
    border-radius: 6px;
    background: ${colorsPalettes.carbon[0]};
    ${setElevation("Z1")};
`;
